import React, { useEffect, useState, cloneElement, isValidElement } from 'react';
import { useLocation } from 'react-router-dom';
import AppHeader from '../components/AppHeader';
import MobileAppHeader from '../components/MobileAppHeader';
import SiteFooter from '../components/SiteFooter';
import MobileFooter from '../components/MobileFooter';
import ToastViewport from '../components/ToastViewport';
import TutorialFloatingButton from '../components/TutorialFloatingButton';
import { logPageView } from '../services/analytics';

const AppLayout = ({ children }) => {
  const location = useLocation();
  const isTutorialRoute = location.pathname === '/tutorial';
  // CHANGED: Also hide header/footer on Anime Vegas landing page
  const isAnimeVegasRoute = location.pathname === '/animevegas';
  const hideHeader = isTutorialRoute || isAnimeVegasRoute;
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = typeof window !== 'undefined' ? window.matchMedia('(max-width: 640px)') : null;
    if (!mq) {
      setIsMobile(false);
      return undefined;
    }
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener?.('change', update);
    return () => mq.removeEventListener?.('change', update);
  }, []);

  // CHANGED: Log page view analytics when route changes
  useEffect(() => {
    const pageName = location.pathname === '/' ? 'Home' : location.pathname.slice(1).replace(/-/g, ' ').replace(/\//g, ' > ');
    logPageView(pageName, location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen">
      <ToastViewport />
      {!hideHeader && (isMobile ? <MobileAppHeader /> : <AppHeader />)}
      <main className={`relative z-0 mx-auto flex w-full flex-col ${hideHeader ? 'px-4 pb-16' : 'w-full max-w-6xl px-4 pb-16 pt-[var(--app-header-offset)] sm:pt-[calc(var(--app-header-offset)+1rem)] sm:px-6'}`}>
        {isValidElement(children) ? cloneElement(children, { isMobile }) : children}
      </main>
      {!hideHeader && (isMobile ? <MobileFooter /> : <SiteFooter />)}
      <TutorialFloatingButton />
    </div>
  );
};

export default AppLayout;
